document.addEventListener('DOMContentLoaded', function() {
  var thumbnailContainers = document.querySelectorAll('.recipe-video');
  thumbnailContainers.forEach(function(container) {
    container.addEventListener('click', function() {
      var videoUrl = container.getAttribute('data-video-url');
      if (videoUrl) {
        // Create the video element
        var videoElement = document.createElement('video');
        videoElement.src = videoUrl;
        videoElement.setAttribute('controls', 'controls');
        videoElement.setAttribute('autoplay', 'autoplay');
        videoElement.style.width = '100%';
        videoElement.style.height = 'auto';

        // Replace the thumbnail with the video
        container.innerHTML = '';
        container.appendChild(videoElement);
      }
    });
  });
});